import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { AzureADB2C } from 'src/environments/aadb2c';

const aadb2c = new AzureADB2C().generateConstants()[window.location.host];

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export const MSALScopes = ['https://authorityuri/user.read'];

export function MSALInstanceFactory() {
  return new PublicClientApplication({
    auth: {
      clientId: aadb2c.CLIENT_ID,
      authority: aadb2c.AUTHORITY,
      knownAuthorities: [aadb2c.AUTH_DOMAIN_NAME],
      redirectUri: aadb2c.REDIRECT_URI,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      //   storeAuthStateInCookie: isIE, // Recommended from Msal docs
    },
    system: {
      allowPlatformBroker: false, // Disables WAM Broker
      loggerOptions: {
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map([['https://graph.microsoft.com/v1.0/me', MSALScopes]]);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: MSALScopes,
    },
    loginFailedRoute: '/login-failed',
  };
}
